import { useView, useSetView, VIEWS } from '@context/ViewContext'
import Icon from '@components/shared/Icon'

import styles from 'styles/SelectView.module.css'

const SelectView = () => {
    const currentView = useView()
    const setCurrentView = useSetView()
    const onClick = () => {
        if (currentView === VIEWS.LIST) setCurrentView(VIEWS.GRID)
        else setCurrentView(VIEWS.LIST)
    }

    return (
        <button onClick={onClick} className={styles.wrapper}>
            <Icon>{ currentView === VIEWS.LIST
                ? 'view_module'
                : 'view_list' }</Icon>
        </button>
    )
}

export default SelectView